/**
 * sessionStatus.js — session lifecycle status vocabulary and badge-class mapping.
 * Pure: no imports, no state, no React. Mirrors missionControl/domain/schema.js#statusPillClass.
 */

// Session lifecycle statuses. A session that leaves `deleting` is gone (no further status).
export const SESSION_STATUS = {
  OPEN: 'open',
  CLOSING: 'closing',
  CLOSED: 'closed',
  DELETING: 'deleting'
};

export function isSessionOpen(session) {
  return !!(session && session.status === SESSION_STATUS.OPEN);
}

export function isSessionTransitioning(session) {
  return !!(session && (session.status === SESSION_STATUS.CLOSING || session.status === SESSION_STATUS.DELETING));
}

export function sessionStatusClass(status) {
  if (status === SESSION_STATUS.CLOSING || status === SESSION_STATUS.CLOSED || status === SESSION_STATUS.DELETING) {
    return 'title-tag-badge-muted';
  }
  // `open` and unknown/missing statuses both render as the steady-state (outlined teal) badge.
  return 'title-tag-badge';
}
